<template>
  <div class="receive-page">
    <AppBar title="WE+会员专属优惠券" :placeholder="true" :zIndex="10" />
    <div class="receive-container">
      <img
        class="bg"
        src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/cab55ff273d0cc69ab216f835266b66c_wh=750_642.png"
        alt=""
      />
      <div class="receive-content">
        <div class="coupon-container">
          <div class="coupon-wrapper">
            <div class="coupon-scroll">
              <div class="coupon-list">
                <div
                  class="coupon-item"
                  v-for="(item, index) in couponList"
                  :key="index"
                >
                  <div class="item-price"
                    ><span class="item-rmb">¥</span
                    ><span class="item-num">10</span></div
                  >
                  <div class="item-right">
                    <div class="item-text">会员无门槛优惠</div>
                    <div class="item-tips">领取后当月有效</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="coupon-front">
            <img
              class="red-image"
              src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/86f1d8c804d44114c7618d7a47bb48d5_wh=710_332.png"
              alt=""
            />
            <div class="receive-btn" v-if="couponList && couponList.length">
              <img
                v-if="[0, -2].includes(couponStatus) || !isVip"
                v-clickBuried
                data-click-buried="CLICK_VIP_LQYHQ"
                v-buried
                data-buried="BG_VIP_LQYHQ"
                @click="bindReceive"
                class="receive-btn-image user-btn"
                src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/742fae02f4269c2375f2bfa7f77fad5d_wh=434_94.png"
                alt=""
              />
              <img
                v-if="couponStatus == 1"
                @click="bindToWeiMengCoupon"
                class="receive-btn-image user-btn"
                src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/4852ff1e18a53df2d3da813e50f05536_wh=434_94.png"
                alt=""
              />
              <img
                v-if="couponStatus == 2"
                @click="bindReceiveFail"
                class="receive-btn-image user-btn"
                src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/5c249a0df5ab185f5badc242d7248832_wh=868_188.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div v-if="goodsList && goodsList.length">
          <div class="order-text">-使用优惠下单-</div>
          <div class="goods-container">
            <img
              class="goods-title"
              src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/9793ac77640d68140d5c2c75482c4b8c_wh=240_58.png"
              alt=""
            />
            <div class="goods-list">
              <div
                class="goods-item"
                v-for="(item, index) in goodsList"
                :key="index"
              >
                <img
                  @click="bindHandleGoods(item)"
                  class="goods-image"
                  :src="item.img"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppLoading class="app-loading" v-if="!loaded" />
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
import AppBar from '@/components/app/nav-bar/index.vue'
export default {
  components: { AppLoading, AppBar },
  data() {
    return {
      info: null,
      isVip: true,
      couponList: [],
      couponStatus: -1, //-2：优惠券初始化中； -1：默认； 0：未领取；1：已领取； 2：领取失败
      loaded: false,
      goodsList: [],
      errMsg: ''
    }
  },
  created() {
    this.init()
    this.getGoodsList()
  },
  methods: {
    async getGoodsList() {
      let params = {
        position_type: '33', //位置类型
        resource_type: '1' //资源位类型
      }
      let res = await this.$http
        .getBaseApp(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.goodsList = res.data
        }
      }
    },
    async init() {
      let promise1 = this.$http.getBaseApp(
        'api/v3/WeplusData/getUserWeplusIdentify',
        {}
      )
      let promise2 = this.$http.getBaseApp(
        'api/v1/WeplusCoupon/getCouponList',
        {}
      )
      let [res1, res2] = await Promise.all([promise1, promise2]).catch(() => {})
      this.loaded = true
      if (res1 && res2) {
        res1 = res1.data
        res2 = res2.data
        if (res2.code == 200) {
          this.couponList = res2.data.record_data
          this.couponStatus = res2.data.coupon_status
        }
        if (res2.code !== 200 && res1.code == 200) {
          this.isVip = res1.data.is_weplus || res1.data.is_old_weplus
          this.couponList = [{}, {}, {}]
          if (this.isVip) {
            this.couponStatus = -2
            this.errMsg = res2.msg
          }
        }
      } else {
        this.$toast('异常错误，请退出重试')
      }
    },
    async getCouponList() {
      let res = await this.$http
        .getBaseApp('api/v1/WeplusCoupon/getCouponList', {})
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.couponList = res.data.record_data
          this.couponStatus = res.data.coupon_status
          if (this.couponStatus == 1) {
            //领取成功埋点
            this.$http.bindH5UMA('CLICK_VIP_LQYHQ_CG')
            this.$toast('领取成功')
          }
          if (this.couponStatus == 2) {
            this.$dialog.alert({
              title: '提示',
              message: '领取失败，请联系大会员客服处理~',
              theme: 'round-button'
            })
          }
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.msg,
            theme: 'round-button'
          })
        }
      }
    },
    bindReceiveFail() {
      this.$dialog.alert({
        title: '提示',
        message: '领取失败，请联系大会员客服处理~',
        theme: 'round-button'
      })
    },
    async bindReceive() {
      if (!this.isVip) {
        this.bindToVip()
        return
      }
      if (this.couponStatus == -2) {
        this.$dialog.alert({
          title: '',
          message: this.errMsg,
          theme: 'round-button'
        })
        return
      }
      this.$toast.loading({
        message: '领取中...',
        forbidClick: true
      })
      let res = await this.$http
        .postBaseApp('api/v1/WeplusCoupon/manualReceiveCoupon', {})
        .catch(() => {})
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.getCouponList()
        } else {
          this.$dialog.alert({
            title: '',
            message: res.msg,
            theme: 'round-button'
          })
        }
      }
    },
    //跳转微盟优惠券页面
    bindToWeiMengCoupon() {
      let urlData = {
        test: 'https://664013846.crm.n.weimob.com/bos/onecrm/664013846/0/12386878846/coupons/coupon-list',
        pro: 'https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/market/coupon/index',
        pre: 'https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/market/coupon/index',
        dev: 'https://664013846.crm.n.weimob.com/bos/onecrm/664013846/0/12386878846/coupons/coupon-list'
      }
      let url = urlData[this.$http.curEv()]
      this.$betterwe.jumpWmStore(url)
    },
    //点击商品
    bindHandleGoods(item) {
      this.$betterwe.onAppPageRoute(item.router)
    },
    bindToVip() {
      this.$dialog.alert({
        title: '',
        message: '请开通会员后领取~',
        theme: 'round-button'
      })
      //this.$betterwe.vipHomePage();
    }
  }
}
</script>
<style lang="scss" scoped>
.receive-page {
  min-height: 100vh;
  background-color: rgba(255, 245, 204, 1);
}
.receive-container {
  overflow: hidden;
  position: relative;
  z-index: 1;
  .bg {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
  }
  .receive-content {
    margin-top: 166px;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .coupon-container {
      margin-bottom: 15px;
      position: relative;
      width: 335px;
      background: linear-gradient(
        to bottom,
        rgba(255, 118, 66, 1),
        rgba(254, 71, 6, 1),
        rgba(254, 70, 5, 1)
      );
      box-shadow: inset 0px 2px 8px rgba(255, 253, 248, 0.57);
      border-radius: 20px;
      .coupon-wrapper {
        margin: -16px auto 0px;
        width: 317px;
        min-height: 387px;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1),
          rgba(252, 251, 237, 1)
        );
        border-radius: 20px;
        border: 1px solid rgba(255, 195, 110, 1);
        box-shadow: 1px -1px 0px rgba(255, 255, 255, 1),
          inset 0px 0px 0px 1px rgba(255, 225, 171, 1);
        .coupon-scroll {
          height: 100%;
          .coupon-list {
            box-sizing: border-box;
            min-height: 385px;
            padding: 15px 16px 120px;
            .coupon-item {
              background-image: url('https://btw-common-data-oss.betterwestar.com/btw-admin/resource/74d823e7df96742b3121905537ba3eaa_wh=570_142.png');
              background-repeat: no-repeat;
              background-size: contain;
              height: 71px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              .item-price {
                width: 113px;
                font-family: DIN;
                font-weight: bold;
                font-size: 15px;
                color: #ff6635;
                line-height: 39px;
                padding-left: 30px;
                .item-num {
                  font-size: 39px;
                }
              }
              .item-right {
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
              }
              .item-text {
                font-weight: bold;
                font-size: 15px;
                color: #672000;
                line-height: 21px;
              }
              .item-tips {
                font-weight: bold;
                font-size: 10px;
                color: rgba(209, 60, 0, 0.5);
                line-height: 14px;
              }
            }
            .coupon-item:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .coupon-front {
        position: absolute;
        left: 50%;
        bottom: -7px;
        transform: translate(-50%, 0%);
        width: 355px;
        height: 166px;
        .red-image {
          width: 100%;
          height: 100%;
        }
        .receive-btn {
          position: absolute;
          transform: translate(-50%, 0%);
          width: 217px;
          height: 47px;
          left: 50%;
          bottom: 30px;
          .receive-btn-image {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .order-text {
    margin-bottom: 15px;
    font-family: MiSans, MiSans;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: #d38a2e;
    line-height: 20px;
  }
  .goods-container {
    width: 345px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 20px;
    padding: 15px 19px 15px 15px;
    margin-bottom: 20px;
    .goods-title {
      margin-left: 6px;
      margin-bottom: 12px;
      height: 29px;
    }
    .goods-list {
      .goods-item {
        margin-bottom: 10px;
        .goods-image {
          width: 100%;
        }
        .goods-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
.app-loading {
  position: fixed;
  z-index: 1;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
</style>
